import React from 'react';
import classes from '../Input/Input.module.scss';
import { PhoneInputProps } from './PhoneInput.types';
import InputWrapper from '../InputWrapper/InputWrapper';
import { formatPhoneNumber } from './helpers';
import { cn } from '../../utils';

/**
 * Specialized phone input component that formats phone numbers as they are typed.
  - imports the styles directly from Input.module.scss
  - uses libphonenumber-js to format phone numbers, a lighter version of google-libphonenumber
  */
const PhoneInput: React.FC<PhoneInputProps> = ({
  label,
  placeholder,
  required,
  disabled,
  name,
  helpText,
  showHelpIcon = false,
  errors,
  errorState,
  onChange,
  onBlur,
  value,
  size = 'default',
  inputProps,
  className = '',
  helpIconTooltipContent,
  tooltipProps,
  defaultCountryCode,
}) => {
  const hasErrors = (errors && errors.length > 0) || errorState;
  const sizeClass = `input__field--${size}`;

  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <>
      <InputWrapper
        label={label}
        required={required}
        name={name}
        helpText={helpText}
        showHelpIcon={showHelpIcon}
        errors={errors}
        className={className}
        helpIconTooltipContent={helpIconTooltipContent}
        tooltipProps={tooltipProps}
      >
        <input
          className={cn(classes['input__field'], classes[sizeClass], {
            [classes['input__field--error']]: hasErrors,
          })}
          id={name}
          name={name}
          data-testid={`phone-input-${name}`}
          type='tel'
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onChange={(e) => {
            e.target.value = formatPhoneNumber(e.target.value, defaultCountryCode);
            onChange && onChange(e);
          }}
          ref={inputRef}
          onKeyUp={(e) => {
            // temporary hack to remove special characters when backspace is pressed
            if (e.key === 'Backspace') {
              const value = inputRef.current?.value;
              const lastChar = value?.slice(-1);
              if (lastChar === ')' || lastChar === '(' || lastChar === '-') {
                e.preventDefault();
                inputRef.current.value = value.slice(0, -1);
              }
            }
          }}
          onBlur={onBlur}
          {...(inputProps as React.InputHTMLAttributes<HTMLInputElement>)}
        />
      </InputWrapper>
    </>
  );
};

export default PhoneInput;
